import ReportingTemplateHeaderModel from '../../models/SystemConfiguration/ReportingTemplateHeaderModel';
import BaseStore from '../BaseStore';

class ReportingTemplateHeaderStore extends BaseStore {
  constructor(transportLayer) {
    super(ReportingTemplateHeaderModel, transportLayer);
  }
}

export default ReportingTemplateHeaderStore;



// WEBPACK FOOTER //
// ./src/stores/SystemConfiguration/ReportingTemplateHeaderStore.js